import { render, staticRenderFns } from "./budget-partial-save-modal.vue?vue&type=template&id=2ff5cbac&"
import script from "./budget-partial-save-modal.vue?vue&type=script&lang=ts&"
export * from "./budget-partial-save-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports